import React from "react";
import styles from "./ProtectedRoute.module.css";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, isAuthLoading, userData }) {
  if (isAuthLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    ); // Replace with a spinner or loader if needed
  }

  if (!userData) {
    return <Navigate to="/login" />;
  }

  return children;
}
